import Link from "next/link";

const Not_Registerd_Yet = ({ handleClosePopup }) => {
  return (
    <div>
      <h2 className="text-white text-[24px] lg:text-[2vw] mb-3">
        Not registered yet?
      </h2>
      <Link
        href={"/registration"}
        className="table border-none bg-[#a3a3a3] text-black py-2 px-5 font-semibold !cursor-pointer hover:bg-white"
        onClick={() => handleClosePopup("mobileNoPopup")}
      >
        Register Now
      </Link>
    </div>
  );
};

export default Not_Registerd_Yet;
